import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import SecuritySidebar from '../../SecurityDashboard/Sidebar/SecuritySidebar';
import Topbar from '../../components/common/Topbar/Topbar';
import styles from '../DashboardLayout.module.css';
import { io } from 'socket.io-client';
import { startSiren, stopSiren } from '../../utils/siren';
import { ShieldAlert } from 'lucide-react';

const SOCKET_URL = import.meta.env.VITE_API_URL ? import.meta.env.VITE_API_URL.replace(/\/api\/?$/, '') : import.meta.env.VITE_API_URL.replace(/\/api\/?$/, '');

const SecurityLayout = () => {
  const [sosAlert, setSosAlert] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const socket = io(SOCKET_URL);

    socket.on('new_sos', (incident) => {
      setSosAlert(incident);
      startSiren();
    });

    return () => {
      socket.disconnect();
      stopSiren();
    };
  }, []);

  const handleAcknowledge = () => {
    setSosAlert(null);
    stopSiren();
  };

  return (
    <div className={styles.layout}>
      {sosAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(220, 38, 38, 0.95)', zIndex: 9999,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontFamily: 'sans-serif'
        }}>
          <ShieldAlert size={100} style={{ animation: 'pulse 1s infinite' }} />
          <h1 style={{ fontSize: '4rem', margin: '20px 0', textAlign: 'center' }}>SOS EMERGENCY!</h1>
          <h2 style={{ fontSize: '2rem', margin: '0 0 40px 0', textAlign: 'center' }}>{sosAlert.description || 'Emergency Triggered!'}</h2>
          <p style={{ fontSize: '1.5rem', marginBottom: '40px' }}>Location: {sosAlert.location || 'Unknown'}</p>
          <button 
            onClick={handleAcknowledge}
            style={{ padding: '20px 60px', fontSize: '1.5rem', fontWeight: 'bold', color: '#dc2626', backgroundColor: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', boxShadow: '0 10px 25px rgba(0,0,0,0.5)' }}
          >
            ACKNOWLEDGE & MUTE
          </button>
        </div>
      )}

      <SecuritySidebar mobileOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className={styles.mainContent}>
        <Topbar 
          onMenuClick={() => setIsSidebarOpen(true)} 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
        <main className={styles.content}>
          <Outlet context={{ searchQuery }} />
        </main>
      </div>
    </div>
  );
};

export default SecurityLayout;
